const SAME_SITE_PATH = /^\/(?![/\\])/;

/** The path in `raw` when it stays on this site (a single leading slash), otherwise null. */
export function asInternalPath(raw: string | null): string | null {
  return raw && SAME_SITE_PATH.test(raw) ? raw : null;
}
